import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import useOutsideInteraction from "../Sidebar/hooks/useOutsideInteraction";
import Avatar from "../Sidebar/components/Avatar";
import useNewLogoutAPI from "../../api/logoutAPI";

export default function UserMenu({ session }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const { logout } = useNewLogoutAPI();

  useOutsideInteraction(menuRef, open, () => setOpen(false));

  return (
    <div className="navbar-user" ref={menuRef}>
      <button
        type="button"
        className="navbar-user__trigger"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <Avatar
          src={session.userImageUrl}
          alt={session.userName}
          className="navbar-user__avatar"
          fit="cover"
        />
        <span className="navbar-user__content">
          <strong>{session.userName || "User"}</strong>
          <small>{session.entityName}</small>
        </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`navbar-user__chevron ${open ? "is-open" : ""}`}
        />
      </button>

      {open ? (
        <div className="navbar-user__menu">
          <button
            type="button"
            className="navbar-user__action"
            onClick={logout}
          >
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
            <span>Logout</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
